    export const apiEndpoints = {
    REGISTER: 'user/register',
    LOGIN: 'user/login',
    SOCIAL_LOGIN: 'user/social/login',
    CHECK_USER: 'user/check',
    SEND_OTP: 'user/send/otp',
    VERIFY_OTP: 'user/verify/otp',
    RESET_PASSWORD: 'user/password/reset',
    LOGOUT: 'user/web/logout',

    GET_PROFILE: 'user/profile/get',
    UPDATE_PROFILE: 'user/profile/update',
    CHANGE_PASSWORD: 'user/password/change',

    GET_ALL_CATEGORIES: 'category/get/all',

    //Social Media
    GET_ALL_SOCIAL_MEDIA: 'social-media/get/all',

    //Testimonial
    GET_TESTIMONIAL: "testimonial/get/all",
    
    GET_HOME_DATA: 'user/home/data/get',
    GET_ALL_VIDEOS: 'video/get/all',

    GET_PRODUCTS: 'user/product/get/all',
    GET_PRODUCT_DETAILS: 'product/details/get',
    SEARCH_PRODUCTS: 'user/product/search',
    GET_PRODUCT_FILTER_PARAMS: 'product/filter/parameters/get',
    FILTER_PRODUCTS: 'user/product/filter',

    ADD_TO_WISHLIST: 'user/whishlist/add',
    REMOVE_FROM_WISHLIST: 'user/whishlist/remove',
    GET_WISHLIST: 'user/whishlist/get',


    ADD_TO_CART: 'user/cart/add',
    
    REMOVE_FROM_CART: 'user/cart/remove',
    GET_CART: 'user/cart/get',

    ADD_ADDRESS: 'user/address/add',
    UPDATE_ADDRESS: 'user/address/update',
    DELETE_ADDRESS: 'user/address/delete',
    GET_ADDRESS: 'user/address/get/all',
    GET_COUNTRIES: 'country/get/all',
    GET_STATE_CITY_DETAILS: 'user/address/get/details',

    PLACE_ORDER: 'user/order/place',
    GET_ORDERS: 'user/order/get/all',
    GET_ORDER_DETAILS: 'order/details/get',
    ADD_REVIEW_RATING: 'user/order/review/add',
    CREATE_ORDER: 'user/order/create',

    RAISE_SUPPORT_TICKET: 'user/support/ticket/raise',
    UPDATE_SUPPORT_TICKET: 'support/ticket/update/status',
    GET_SUPPORT_TICKETS: 'user/support/ticket/get/all',
    ADD_MESSAGE_TO_TICKET: 'support/ticket/add/message',
    GET_SUPPORT_CHAT_HISTORY: 'support/ticket/get/chats',

    GET_NOTIFICATIONS: 'user/notification/get/all',

    GET_ADMIN_BANK_DETAILS: 'admin/bank/details/get',

}